import type { ReactNode } from 'react';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { useManualEditRegistration } from '../manualEditsLegend/ManualEditsLegendContext';
import { ManualEditMarker, VisuallyHidden } from '../ScenarioGrid.style';

type ScenarioManualEditMarkerProps = {
    enabled: boolean;
    show: boolean;
    message: string;
    testId: string;
    isManualEdit?: boolean;
    children: ReactNode;
};

export const ScenarioManualEditMarker = ({
    enabled,
    show,
    message,
    testId,
    isManualEdit = true,
    children
}: ScenarioManualEditMarkerProps) => {
    const theme = useInterstateTheme();
    const isMarked = enabled && show;

    useManualEditRegistration(isMarked && isManualEdit);

    return (
        <ManualEditMarker $isMarked={isMarked} theme={theme} data-testid={isMarked ? testId : undefined}>
            {children}
            {isMarked && <VisuallyHidden>{message}</VisuallyHidden>}
        </ManualEditMarker>
    );
};
